import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=1ea8931b&scoped=true&"
import script from "./forgot.vue?vue&type=script&lang=ts&"
export * from "./forgot.vue?vue&type=script&lang=ts&"
import style0 from "./forgot.vue?vue&type=style&index=0&id=1ea8931b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8931b",
  null
  
)

export default component.exports